<template>
    <v-form ref="documentForm" :value="documentFormValue">
      <v-container class="component_main px-7">
        <v-row >
          <v-col>
            <h1>{{formData.id?'Editar documento':'Novo documento'}}</h1>
            <p>Compartilhe documentos com clientes.</p>
          </v-col>
        </v-row>
        <v-row >
          <v-col cols="12" sm="12" md="4">
            <label>Prestadores</label>
            <GruposPrestadoresSelect :selecionados="selecao" :selectPrestadores="(dataSelection)=> updatePrestadores(dataSelection)"/>
          </v-col>
          <v-col cols="8" md="4" sm="12">
            <label>Classificação</label>
            <v-select
              v-model="formData.modulo"
              :items="modulosList"
              item-text="label"
              item-value="value"
              :rules="required"
              placeholder="Módulo a que se refere"
              outlined
              dense
              @change="(value) => loadPerfis(value)"
            ></v-select>
          </v-col>
        </v-row>
        <v-row >
          <v-col cols="8" md="4" sm="12">
            <label>Tipo de documento</label>
            <v-select
              v-model="formData.tipo"
              :items="docTipos"
              :rules="required"
              placeholder="O que é"
              dense
              outlined
              item-text="descricao"
              item-value="id"
            ></v-select>
          </v-col>
          <v-col cols="8" sm="12" md="4">
            <label>Perfis de Acesso</label>
            <v-autocomplete
              v-model="formData.permissao"
              :label="disableProfiles? 'Selecione antes a classificação': 'Selecione um ou mais perfis'"
              :items="perfis_acesso"
              :menu-props="{ maxHeight: '400' }"
              :rules="required"
              :disabled="disableProfiles"
              chips
              multiple
              outlined
              solo
              flat
              dense
              item-value="value"
              item-text="label"
              :search-input.sync="searchInput"
            >
              <template v-slot:prepend-item>
                <v-list-item ripple @click="togglePerfis">
                  <v-list-item-content>
                    <v-list-item-title>Todos</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
              <template v-slot:selection="data">
                <v-chip
                  v-bind="data.attrs"
                  :input-value="data.selected.value"
                  close
                  small
                  @click:close="removePerfil(data.item.value)"
                  label
                >{{ data.item.label }}</v-chip>
              </template>
              <template v-slot:item="data">
                  <v-list-item @click="toggleAutocomplete(data.item, 'permissao')" :class="formData.permissao.includes(data.item.value)? 'primary--text v-list-item--active': ''">
                    <v-list-item-content>
                      <v-list-item-title>{{data.item.label}}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row >
          <v-col cols="8" md="4" sm="12">
            <label>Descrição</label>
            <v-text-field
              v-model="formData.descricao"
              :rules="required"
              placeholder="O que é"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="8" md="4" sm="12">
            <label>Data de publicação</label>
            <v-menu
              ref="dataPublicacaoDocs"
              v-model="dataPublicacaoDocs"
              :close-on-content-click="true"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dataPublicacao"
                  placeholder="Data em que estará disponível"
                  format="DD/MM/YYYY"
                  v-mask="'##/##/####'"
                  dense
                  outlined
                  append-icon="mdi-calendar"
                  v-bind="attrs"
                  :rules="[formRules.requiredField, formRules.typeDateFormated]"
                  v-on="on"
                  @blur="data_publicacao = parseDate(dataPublicacao)"
                ></v-text-field>
              </template>
              <v-date-picker color="primary" 
                v-model="data_publicacao"
                no-title
                @input="dataPublicacaoDocs = false"
              ></v-date-picker>
          </v-menu>
          </v-col>
        </v-row>
        <v-row class="px-2">
          <!-- <v-col cols="8" md="4" sm="12">
            <label>Data de expiração</label>
            <v-menu
              ref="dt_expiracao_bool"
              v-model="dt_expiracao_bool"
              :close-on-content-click="false"
              :return-value.sync="date"
              transition="scale-transition"
              offset-y
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="formData.DataExpiracao"
                  dense
                  v-mask="'##/##/####'"
                  placeholder="Opcional"
                  label
                  outlined
                  v-bind="attrs"
                  v-on="on"
                  append-icon="mdi-calendar-blank"
                  @blur="formData.DataExpiracao = parseDate(formData.DataExpiracao)"
                  :rules="[formRules.typeDateFormated]"
                ></v-text-field>
              </template>
              <v-date-picker color="primary"  v-model="date" no-title scrollable></v-date-picker>
            </v-menu>
          </v-col> -->
          <v-col cols="8" md="4" sm="12" class="d-flex align-center">
            <v-switch
              x-small
              v-model="formData.is_visible"
              inset
              :label="'Documento vísivel pelos usuários'"
            ></v-switch>
          </v-col>
        </v-row>
        <v-row class="px-2">
          <v-col cols="12" md="4" sm="12">
            <vue-dropzone
              :rules="required"
              ref="fileDropzone"
              class="pa-0"
              id="dropzone"
              :options="dropzoneOptions"
              @vdropzone-max-files-exceeded="(file) => addedFile(file)"
              @vdropzone-error="(file, message, xhr) => rejectedFile(file, message, xhr)"
            ></vue-dropzone>
            <!--  $refs.fileDropzone.removeFile(file) -->
          </v-col>
        </v-row>
        <v-row class="px-2">
          <v-col cols="12" class="d-flex align-center justify-end">
            <v-btn height="30px" small outlined color="primary" @click="close()">Cancelar</v-btn>
            <v-spacer></v-spacer>
            <v-btn height="30px" small depressed color="primary" @click="validate()">Salvar</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
</template>
<script>
import { mapState, mapGetters } from "vuex"
import GruposPrestadoresSelect from '@/components/common/GruposPrestadoresSelect'
import vue2Dropzone from "vue2-dropzone"
import "vue2-dropzone/dist/vue2Dropzone.min.css"

// import axios from 'axios'
// import FormData from 'form-data'
// import fs from 'fs'

const formDataInicial = {
  data_publicacao: null,
  descricao: null,
  doc_id: null,
  id: null,
  is_visible: false,
  nome: null,
  permissao: [],
  prestador: [],
  tipo: null,
  modulo: null
}
export default {
  components: {
    vueDropzone: vue2Dropzone,
    GruposPrestadoresSelect
  },
  props:{
    modules: Array,
    docTipos: Array,
    close: Function,
    selectedItem: String
  },
  data() {
    return {
      prestadoresList: [],
      dropzoneOptions: {
        url: process.env.VUE_APP_API_URL,
        resizeWidth: 200,
        resizeHeight: 50,
        maxFilesize: 4,
        maxFiles: 1,
        autoProcessQueue: false,
        dictDefaultMessage:
         `<v-row class='d-flex align-center'>
          <v-col class='col-xs-3 col-sm-2 col-md-1'>
          <div class='mdi mdi-file-outline primary--text' style='font-size: 35px; color: #18a0fb;'></div>
          </v-col>
          <v-col class='col-xs-9 col-sm-10 col-md-11'>
          <div style='font-size: 12px'>Arraste o arquivo ou <span class='primary--text'>selecione</span><br>Faça upload de arquivos com até 4MB</p></v-col>
          </v-row>`
      },
      formData: {
        grupo_economico: null,
        data_publicacao: null,
        descricao: null,
        doc_id: null,
        id: null,
        is_visible: false,
        nome: null,
        permissao: [],
        prestador: [],
        tipo: null,
        modulo: null
      },
      file: null,
      modulosList:[],
      isNew: true,
      documentFormValue: true,
      required: [(v) => !!v || "Por favor preencha o campo."],
      requestAnswer: "",
      dataPublicacao: null,
      data_publicacao: null,
      dataPublicacaoDocs: false,
      dt_expiracao_bool: false,
      disableProfiles: true,
      perfis_acesso: [],
      clientes: [],
      clientesNorm: [],
      searchInput: null,
      selecao: [],
    };
  },
  computed: {
    ...mapState({
      formRules: state => state.formRules,
      modulos: state => state.permissions.permissaoBaseCadastro,
    }),
    ...mapGetters({
      getModulosList: "permissions/getModulosList",
      getPermissoesModulo: "permissions/getPermissoesModulo"
    }),
    selectAllPerfis() {
      return this.formData.permissao.length === this.perfis_acesso.length;
    },
    // selectSomePerfis() {
    //   return this.formData.permissao.length > 0 && !this.selectAllPerfis;
    // },
    // iconPerfis() {
    //   if (this.selectAllPerfis) return "mdi-close-box";
    //   if (this.selectSomePerfis) return "mdi-minus-box";
    //   return "mdi-checkbox-blank-outline";
    // },
  },
  watch: {
    dataPublicacao(){
      this.formData.data_publicacao = this.parseDate(this.dataPublicacao)
    },
    data_publicacao(){
        this.dataPublicacao = this.formatDate(this.data_publicacao)
        this.formData.data_publicacao = this.data_publicacao
    },
    selectedItem:{
      deep: true,
      handler(val){
        // this.dataExpiracao = null
        this.dataPublicacao = null
        this.$refs.fileDropzone.removeAllFiles()
        this.$refs.documentForm.reset()
        let item = JSON.parse(val) 
        this.isNew = item == {}
        this.$nextTick(()=>{
          item.tipo = Number(item.tipo)
          item.data_publicacao = item.data_publicacao? item.data_publicacao.split('T')[0]: null
          this.selecao = item.prestador
          this.dataPublicacao = this.formatDate(item.data_publicacao)
          this.formData = (this.isNew)? {...formDataInicial} : {...item}
            this.$nextTick(()=>{
              if(item.modulo) {
               this.loadPerfis(item.modulo, item.permissao)
              }
            })
        })
      }
    },
  },
beforeMount(){
  let array = this.getModulosList()
  array.unshift({value: null, label: "Selecione"});
  this.modulosList = array
},
  methods: {
    async addedFile(file) {
      await this.$refs.fileDropzone.removeAllFiles();
      this.$refs.fileDropzone.addFile(file);
    },
    toggleAutocomplete(item, campo) {
      this.searchInput = null
      let index = this.formData[campo].indexOf(item.value)
      //  index > -1  está excluindo a operadora
      if (index > -1) {
        this.formData[campo].splice(index, 1)
      } else {
        //  index < 0  está adicionando a operadora
          this.formData[campo].push(item.value)
      }
        this.$nextTick()
        return
    },
    rejectedFile(file, message){
      this.$refs.fileDropzone.removeAllFiles()
      if(!File.accepted && message.indexOf('File is too big')>-1){
        let paramModal = {
            type: "warning",
            title: "Atenção!",
            message: "Não foi possível selecionar o arquivo.<br> Verifique se o tamanho não excede o máximo permitido.",
            callback: null,
            btConfirm: { name: "Ok", show: true },
          }
          this.$store.commit("confirmMessage/showConfirmMessage", paramModal)
      }
    },
    formatDate (date) {
        if (!date) return null
        
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
    },
    parseDate (date) {
        if (!date) return null

        const [day, month, year] = date.split('/')
        return `${year}-${month}-${day}`
    },
    updatePrestadores(val) {
      this.formData.prestador =  val.filter(el => !!el)
    },
    validate() {
      this.file = this.$refs.fileDropzone.getQueuedFiles()[0];
      this.formData.nome = this.file? this.file.name : this.formData.nome

      if (!this.$refs.documentForm.validate() || (this.isNew && this.file == null)) {
        return
      }

      if(this.file != undefined && this.file != null) {
        this.formData.doc_id = null
      }
        let paramModal = {
          type: "success",
          title: "Sucesso",
          message: "Você poderá editar novamente quando necessário",
          callback: () => this.close(this.formData, this.file),
          btConfirm: { name: "Salvar", show: true },
          btCancel: { name: "Cancelar", show: true },
        }
      this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
    },
    loadPerfis(modulo, permissao){
      this.perfis_acesso = this.getPermissoesModulo(modulo);
      this.disableProfiles = false;
      this.formData.permissao = permissao? permissao : []
    },
    removePerfil(item) {
      const index = this.formData.permissao.indexOf(item);
      if (index >= 0) this.formData.permissao.splice(index, 1);
    },
    togglePerfis() {
      this.$nextTick(() => {
        if (this.selectAllPerfis) {
          this.formData.permissao = [];
        } else {
          this.formData.permissao = this.perfis_acesso.map(el=> el.value);
        }
      });
    },
  },
};
</script>
<style>
.dropzone,
.dz-preview {
  min-height: 0 !important;
  margin: 0 !important;
  padding: 0 !important;
}
.dropzone {
  border-style: dashed;
  height: 120px;
  text-align: center;
}
.dz-preview {
  height: 100px;
  margin: 7px !important;
  width: 70%;
}
.dz-default,
.dz-default span {
  height: 100px;
}
</style>